import axios from "axios";

export * from "./routes.constants";

//export const baseURL = "https://backend.aahera.com.ng/api/v1";

//export const baseURL = "https://api.aahera.com.ng/api/v1";
export const baseURL = "https://live.backend.theracedarzone.com.ng/api/v1";

const axiosInstance = axios.create({
  baseURL,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/json ",
  },
});

const addTokenToRequest = async (req) => {
  const token = localStorage.getItem("11#221#");
  req.headers.Authorization = `Bearer ${token}`;
  return req;
};

axiosInstance.interceptors.request.use(addTokenToRequest);

export default axiosInstance;
